module.exports = __webpack_public_path__ + "img/1670830642871-IMG-20221212-WA0000.jpg.3bdf3f7c.webp";